// @flow

import * as React from 'react';

// $FlowFixMe
import { StylesProvider } from '@material-ui/styles';

import DefaultTheme from './default_theme';

import {
  StyledDialog,
  StyledDialogContent,
  StyledDialogActions,
  StyledTitleSection,
} from './shared';

type Props = {
  children: React.Node,
};

const StyledModal = (props: Props) => {
  const { children } = props;

  return (
    <StylesProvider injectFirst>
      <DefaultTheme>{children}</DefaultTheme>
    </StylesProvider>
  );
};

StyledModal.Header = StyledTitleSection;
StyledModal.Container = StyledDialog;
StyledModal.Content = StyledDialogContent;
StyledModal.Footer = StyledDialogActions;

export default StyledModal;

export {
  StyledModal as Modal,
  StyledTitleSection as Header,
  StyledDialog as Container,
  StyledDialogContent as Content,
  StyledDialogActions as Footer,
};
